import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { AiOutlineSearch } from "react-icons/ai";
import "./style.scss";
class NormalInputClass extends Component {
  render() {
    let {
      className = "form-control",
      placeholder = "",
      onChange,
      value = "",
      name,
      disabled = false,
      type = "text",
      iconname = "",
      onClick,
      onDoubleClick,
      onFocus = () => {},
      onBlur = () => {},
      t,
      max,
      maxLength,
      onKeyDown,
      id,
      iconsVisible = false,
      onClickIcon,
      iconType = 1,
    } = this.props;

    return (
      <>
        {iconname !== "" ? (
          <span className={`${iconname} input-icon`}></span>
        ) : (
          ""
        )}
        <input
          id={id}
          className={`inputSearchBtnContainer ${className} ${
            iconname !== "" ? "pl-5" : ""
          }`}
          name={name}
          type={type}
          disabled={disabled}
          value={value ?? ""}
          min={0}
          max={max}
          maxLength={maxLength}
          placeholder={t(placeholder)}
          autoComplete="off"
          onFocus={onFocus}
          onBlur={onBlur}
          onClick={onClick ? onClick : () => {}}
          onDoubleClick={onDoubleClick ? onDoubleClick : () => {}}
          onKeyDown={onKeyDown}
          onChange={(e) => {
            console.log(e);
            let body = {};

            body = {
              target: {
                name: e.target.name,
                value: e.target.value,
              },
            };

            onChange(body);
          }}
        />
        {iconsVisible && (
          <AiOutlineSearch
            className={
              iconType === 1
                ? "searchInputIcon"
                : iconType === 2
                ? "searchInputIcon1"
                : "searchInputIcon2"
            }
            color="#023f88"
            size={25}
            onClick={onClickIcon}
          />
        )}
      </>
    );
  }
}

export const NormalInput = withTranslation()(NormalInputClass);
